import { createInertiaApp } from "@inertiajs/react";
import { createElement, ReactNode } from "react";
import { createRoot } from "react-dom/client";
import BaseLayout from "@/layout/base-layout";

type PageComponent = React.ComponentType<any> & {
  layout?: (page: ReactNode) => ReactNode;
};

type ResolvedComponent = {
  default: PageComponent;
  layout?: (page: ReactNode) => ReactNode;
};

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<ResolvedComponent>("../pages/**/*.tsx", {
      eager: true,
    });
    const page = pages[`../pages/${name}.tsx`];
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`);
    }

    // Se a página não tem layout definido, usar o layout padrão
    if (page.default.layout === undefined) {
      page.default.layout = (pageContent: ReactNode) => (
        <BaseLayout>{pageContent}</BaseLayout>
      );
    }

    return page;
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(createElement(App, props));
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.'
      );
    }
  },
});
